import { json } from "react-router-dom";
import { postRequest, postFormDataRequest } from "../apiHelpers";
import {
	getVehicleBrand, getVehicleBrandById, addVehicleBrand, editVehicleBrand, deleteVehicleBrand,
	getPolicy, getPolicyById, addPolicy, editEditPolicy, deletePolicy, getPolicyTypeAll,
	getUserManagement, getUserManagementById, addUserManagement, editUserManagement, deleteUserManagement,
	searchUserByKey, getAllProvince, getDistrict, getRoles, cmsChangePassword,
	getSpecialAgentCommision, getSpecialAgentCommisionById, addSpecialAgentCommision, editSpecialAgentCommision, deleteSpecialAgentCommision,
	uploadFile, getSearchAgentInfo, approveRejectedSpecialAgentCommision,
	getMainMenu, getSubMenuByKey, grandPermission, getGrandUserPerssion, deleteGrandUserPerssion, getGrandUserPerssionById,
	getPermissionControls, saveWebMenu, deleteWebMenu, getUserActionLogsURL, getUserActionLogByIdURL,
	getAppControls, addAppControls, editAppControls, getAppControlsById, deleteAppControls,
	getDiscounts, addDiscounts, editDiscounts, deleteDiscounts, getDiscountsById,
	deleteFile
} from "../pathApi";
import { createAsyncThunk } from "@reduxjs/toolkit";

//Vehicle Brand
export const callGetVehicleBrand = createAsyncThunk(getVehicleBrand, async (body) => {
	try {
		const response = await postRequest({ url: getVehicleBrand, data: body, showLoading: false });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetVehicleBrandById = createAsyncThunk(getVehicleBrandById, async (body) => {
	try {
		const response = await postRequest({ url: getVehicleBrandById, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callAddVehicleBrand = createAsyncThunk(addVehicleBrand, async (body) => {
	try {
		const response = await postRequest({ url: addVehicleBrand, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callEditVehicleBrand = createAsyncThunk(editVehicleBrand, async (body) => {
	try {
		const response = await postRequest({ url: editVehicleBrand, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callDeleteVehicleBrand = createAsyncThunk(deleteVehicleBrand, async (body) => {
	try {
		const response = await postRequest({ url: deleteVehicleBrand, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

//Policy
export const callGetPolicy = createAsyncThunk(getPolicy, async (body) => {
	try {
		const response = await postRequest({ url: getPolicy, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetPolicyById = createAsyncThunk(getPolicyById, async (body) => {
	try {
		const response = await postRequest({ url: getPolicyById, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callAddPolicy = createAsyncThunk(addPolicy, async (body) => {
	try {
		const response = await postRequest({ url: addPolicy, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callEditEditPolicy = createAsyncThunk(editEditPolicy, async (body) => {
	try {
		const response = await postRequest({ url: editEditPolicy, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callDeletePolicy = createAsyncThunk(deletePolicy, async (body) => {
	try {
		const response = await postRequest({ url: deletePolicy, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetPolicyTypeAll = createAsyncThunk(getPolicyTypeAll, async (body) => {
	try {
		const response = await postRequest({ url: getPolicyTypeAll, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

//User
export const callGetUserManagement = createAsyncThunk(getUserManagement, async (body) => {
	try {
		const response = await postRequest({ url: getUserManagement, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callGetUserManagementById = createAsyncThunk(getUserManagementById, async (body) => {
	try {
		const response = await postRequest({ url: getUserManagementById, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callAddUserManagement = createAsyncThunk(addUserManagement, async (body) => {
	try {
		const response = await postRequest({ url: addUserManagement, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callEditUserManagement = createAsyncThunk(editUserManagement, async (body) => {
	try {
		const response = await postRequest({ url: editUserManagement, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callDeleteUserManagement = createAsyncThunk(deleteUserManagement, async (body) => {
	try {
		const response = await postRequest({ url: deleteUserManagement, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callSearchUserByKey = createAsyncThunk(searchUserByKey, async (body) => {
	try {
		const response = await postRequest({ url: searchUserByKey, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callGetAllProvince = createAsyncThunk(getAllProvince, async (body) => {
	try {
		const response = await postRequest({ url: getAllProvince, data: body, showLoading: false });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callGetDistrict = createAsyncThunk(getDistrict, async (body) => {
	try {
		const response = await postRequest({ url: getDistrict, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callGetRoles = createAsyncThunk(getRoles, async (body) => {
	try {
		const response = await postRequest({ url: getRoles, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callCmsChangePassword = createAsyncThunk(cmsChangePassword, async (body) => {
	try {
		const response = await postRequest({ url: cmsChangePassword, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callGetSpecialAgentCommision = createAsyncThunk(getSpecialAgentCommision, async (body) => {
	try {
		const response = await postRequest({ url: getSpecialAgentCommision, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callGetSpecialAgentCommisionById = createAsyncThunk(getSpecialAgentCommisionById, async (body) => {
	try {
		const response = await postRequest({ url: getSpecialAgentCommisionById, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});


export const callAddSpecialAgentCommision = createAsyncThunk(addSpecialAgentCommision, async (body) => {
	try {
		const response = await postRequest({ url: addSpecialAgentCommision, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callEditSpecialAgentCommision = createAsyncThunk(editSpecialAgentCommision, async (body) => {
	try {
		const response = await postRequest({ url: editSpecialAgentCommision, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callDeleteSpecialAgentCommision = createAsyncThunk(deleteSpecialAgentCommision, async (body) => {
	try {
		const response = await postRequest({ url: deleteSpecialAgentCommision, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callUploadFile = createAsyncThunk(uploadFile, async ({ files, folderName, referenceName }) => {
	try {
		let newUrl = uploadFile.replace(":folderName", folderName).replace(":referenceName", referenceName)
		const formData = new FormData();
		for (let i = 0; i < files.length; i++) {
			formData.append("file", files[i]);
		}
		formData.append("referenceName", referenceName);
		formData.append("folderName", folderName);
		const response = await postFormDataRequest({ url: newUrl, formData });
		return response;
	} catch (error) {
		throw error
	}
});
export const callDeleteFile = createAsyncThunk(deleteFile, async (body) => {
	try {
		const response = await postRequest({ url: deleteFile, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callSearchAgentInfo = createAsyncThunk(getSearchAgentInfo, async (body) => {
	try {
		const response = await postRequest({ url: getSearchAgentInfo, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callApproveRejectedSpecialAgentCommision = createAsyncThunk(approveRejectedSpecialAgentCommision, async (body) => {
	try {
		const response = await postRequest({ url: approveRejectedSpecialAgentCommision, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

// User Permission
export const callGetMainMenu = createAsyncThunk(getMainMenu, async (body) => {
	try {
		const response = await postRequest({ url: getMainMenu, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callGetSubMenu = createAsyncThunk(getSubMenuByKey, async (body) => {
	try {
		const response = await postRequest({ url: getSubMenuByKey, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callGrandPermission = createAsyncThunk(grandPermission, async (body) => {
	try {
		const response = await postRequest({ url: grandPermission, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callGetGrandUserPerssion = createAsyncThunk(getGrandUserPerssion, async (body) => {
	try {
		const response = await postRequest({ url: getGrandUserPerssion, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callDeleteGrandUserPerssion = createAsyncThunk(deleteGrandUserPerssion, async (body) => {
	try {
		const response = await postRequest({ url: deleteGrandUserPerssion, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callGetGrandUserPerssionById = createAsyncThunk(getGrandUserPerssionById, async (body) => {
	try {
		const response = await postRequest({ url: getGrandUserPerssionById, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callGetPermissionControls = createAsyncThunk(getPermissionControls, async (body = {}) => {
	try {
		const response = await postRequest({ url: getPermissionControls, data: body, showLoading: false });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callSaveWebMenu = createAsyncThunk(saveWebMenu, async (body) => {
	try {
		const response = await postRequest({ url: saveWebMenu, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callDeleteWebMenu = createAsyncThunk(deleteWebMenu, async (body) => {
	try {
		const response = await postRequest({ url: deleteWebMenu, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

//App controls
export const callGetAppControls = createAsyncThunk(getAppControls, async (body) => {
	try {
		const response = await postRequest({ url: getAppControls, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callGetAppControlsById = createAsyncThunk(getAppControlsById, async (body) => {
	try {
		const response = await postRequest({ url: getAppControlsById, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callDeleteAppControls = createAsyncThunk(deleteAppControls, async (body) => {
	try {
		const response = await postRequest({ url: deleteAppControls, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callAddAppControls = createAsyncThunk(addAppControls, async (body) => {
	try {
		const response = await postRequest({ url: addAppControls, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callEditAppControls = createAsyncThunk(editAppControls, async (body) => {
	try {
		const response = await postRequest({ url: editAppControls, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callGetDiscounts = createAsyncThunk(getDiscounts, async (body) => {
	try {
		const response = await postRequest({ url: getDiscounts, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callAddDiscounts = createAsyncThunk(addDiscounts, async (body) => {
	try {
		const response = await postRequest({ url: addDiscounts, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callEditDiscounts = createAsyncThunk(editDiscounts, async (body) => {
	try {
		const response = await postRequest({ url: editDiscounts, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callDeleteDiscounts = createAsyncThunk(deleteDiscounts, async (body) => {
	try {
		const response = await postRequest({ url: deleteDiscounts, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

export const callGetDiscountsById = createAsyncThunk(getDiscountsById, async (body) => {
	try {
		const response = await postRequest({ url: getDiscountsById, data: body });
		return response;
	} catch (error) {
		throw error;
	}
});

// User Action Log
export const callGetUserActionLogs = createAsyncThunk(getUserActionLogsURL, async (body) => {
    try {
        return await postRequest({ url: getUserActionLogsURL, data: body, showLoading: true });
    } catch (error) {
        throw error;
    }
});

export const callGetUserActionLogById = createAsyncThunk(getUserActionLogByIdURL, async (body) => {
    try {
        return await postRequest({ url: getUserActionLogByIdURL, data: body, showLoading: true });
    } catch (error) {
        throw error;
    }
});
